import { createFileRoute } from '@tanstack/react-router';

import { ReferFriendsPage } from './ReferFriendsPage';

export const Route = createFileRoute('/_protected/_consumer/refer-friends/')({
  component: ReferFriendsPage,
});
